<div class="panel panel-default">
    <div class="panel-heading" style="display: flex;justify-content: space-between">
    <span (click)="back()" style="cursor: pointer" class="hidden-xs" *ngIf="showGoBack"><i class="fa fa-angle-left"></i>
      <span style="padding-bottom: 1px; border-bottom: 1px dotted white;margin-left: 5px;">{{'Go Back' | translate}}</span> </span>
        <span class="{{showGoBack ? 'pull-right' : ''}}"><i class="fa {{icon}}"></i> {{title}}</span>
    </div>
    <div class="panel-body">
        <ng-content></ng-content>
    </div>
</div>
